/**
 * Generated runtime TestId mirror for frontend/src/pages/ValueLists.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ValueListsTestIds = {
  btnCreateValueList: "btn-create-value-list",
  colActive: "col-active",
  colDescription: "col-description",
  colDisplayName: "col-display-name",
  colName: "col-name",
  inputVlDescription: "input-vl-description",
  inputVlDisplayName: "input-vl-display-name",
  inputVlName: "input-vl-name",
  valueLists: "value-lists",
  valueListRow: (list_id: string) => `value-list-row-${list_id}`,
  valueListRowPrefix: () => "value-list-row-" as TestIdPrefix
} as const;
